import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { wait } from 'Src/me/pages/guest/proposals/new/utils';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { buildUserAnswerMessage } from '../utils';
import { PREFECTURE_NAME_TO_ID } from './consts/prefectureNameToId';
import { renderCityModal } from '../../views/CityModal';
import { hideLoading, showLoading } from '../../../utils';
import { fetchCitiesByPrefecture } from '../../../api/citiesByPrefecture';

const SECTION_KEY_NAME = 'city';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'city';

export const citySection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const prefectureValue = userAnswers.find((answer) => answer.keyName === 'prefecture')?.value;
  const prefectureId = PREFECTURE_NAME_TO_ID.find((prefecture) => prefecture.value === prefectureValue)?.id;

  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '市区町村は',
      answer: textContent || '',
      value: textContent || '',
    });

    // 市区町村は別でIDも保存
    userAnswers.push({
      keyName: 'cityId',
      paramName: 'cityId',
      question: '市区町村IDは',
      answer: value || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        市区町村はどちらになりますか？
      </>
    ),
  });

  // ローディング表示
  showLoading();

  // 市区町村の取得
  const fetchCitiesResult = await fetchCitiesByPrefecture(prefectureId);
  await wait(0.8);

  // ローディング非表示
  hideLoading();

  // 市区町村モーダルを表示
  const answer = await renderCityModal({
    ...props,
    keyName: SECTION_KEY_NAME,
    answerHandler,
    ...fetchCitiesResult,
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        お調べしたところ、近隣を含め61件の塗装業者が見つかりました。
      </>
    ),
    loadingTime: 4,
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    isVisibleAvatar: true,
    messageElement: (
      <>
        お客様に合った業者をお出しするために、再度絞り込みを行います。
      </>
    ),
  });

  // 回答内容を返却する
  return answer;
};
